export default {
    ledger: '\ue601',
    'angle-left': '\ue645',
    trash: '\ue625',
    pen: '\ue69b',
    close: '\ue642',
    confirm: '\ue712',
    gear: '\ue722',
    user: '\ue665',
    calendar: '\ue74b',
    chart: '\ue605',

    plus: '\ue641',
    minus: '\ue624',
    mutiplication: '\ue642',
    division: '\ue608',
    backspace: '\ue623',
    equals: '\ue6c7',

    success: '\ue604',
    info: '\ue72d',
    error: '\ue610',
    warn: '\ue610',

    /* 商标 */
    qq: '\ue60a',
    weibo: '\ue646',
    github: '\ue64a'
}